require('angular');
require('angular-route');
require('angular-resource');
require('angular-animate');
require('angular-aria');
require('angular-messages');
require('angular-material');
require('angular-ui-bootstrap');
//require('angular-ui-router');
require('angular-cookies');
require('angular-jwt');
require('angular-storage');
require('sortablejs');
require('angular-legacy-sortablejs-maintained');



// WEBPACK FOOTER //
// ./src/angular.js